import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonType } from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Footer.styles';

type FooterContinueProps = {
  onContinue?: () => void;
};

export const FooterContinue: FC<FooterContinueProps> = ({ onContinue }) => {
  const isDark = useThemeMode('dark');
  const { t } = useTranslation();

  return (
    <S.FooterWrapper $isSticky>
      <S.ActionButton
        $isDark={isDark}
        $type={ButtonType.DEFAULT}
        onClick={onContinue}
      >
        <S.ActionButtonLabel $isDark={isDark} $type={ButtonType.DEFAULT}>
          {t('Advertise.btn_continue')}
        </S.ActionButtonLabel>
      </S.ActionButton>
    </S.FooterWrapper>
  );
};
